import { render } from "./BrowsePortfolioList.vue?vue&type=template&id=21c1f438"
import script from "./BrowsePortfolioList.vue?vue&type=script&lang=js"
export * from "./BrowsePortfolioList.vue?vue&type=script&lang=js"

import "./BrowsePortfolioList.vue?vue&type=style&index=0&id=21c1f438&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QVirtualScroll});
